export const billingBillType = {
  consumption: 'Consumo',
  service: 'Tarifa',
  payment: 'Pagamento',
  informational_only: 'Apenas informativo',
};
